import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';

export const ResidentDiscountInfo = ({ showBullets, hasNonAdults }) => (
    <React.Fragment>
        { hasNonAdults ? (
            <p className="odf-text-sm odf-text-left">
                <CMS id='flightsManager.residentDiscount.nodiscountinfopassengers' dangerouslySetInnerHTML />
            </p>
        ) : (
            <React.Fragment>
                { showBullets && (
                    <ul className="odf-ol-indicators">
                        <li className="odf-li">
                            <p className="odf-li-content">
                                <span className="odf-text-sm">
                                    <CMS id='flightsManager.residentDiscount.ifresident' />
                                </span>
                            </p>
                        </li>
                        <li className="odf-li">
                            <p className="odf-li-content">
                                <span className="odf-text-sm">
                                    <CMS id='flightsManager.residentDiscount.info' />
                                </span>
                            </p>
                        </li>
                    </ul>
                )}
            </React.Fragment>
        )}
    </React.Fragment>
);

ResidentDiscountInfo.propTypes = {
    showBullets: PropTypes.bool,
    hasNonAdults: PropTypes.bool.isRequired,
};

ResidentDiscountInfo.defaultProps = {
    showBullets: true,
};
